const MONITORING_BASE_URL = 'https://tophamtechbeb.com/aw-monitor/v1';

export const ANALYTICS_RANGES = ['7d', '30d', '120d'];

const getAuthorizationHeader = (user) => {
  if (!user?.token) {
    throw new Error('Your session is missing an authentication token. Please sign in again.');
  }

  return `${user.type || 'Bearer'} ${user.token}`;
};

export const getAnalyticsDashboard = async ({ user, range = '30d', signal } = {}) => {
  if (!ANALYTICS_RANGES.includes(range)) {
    throw new Error('Unsupported analytics date range.');
  }

  const response = await fetch(`${MONITORING_BASE_URL}/analytics/dashboard?range=${range}`, {
    method: 'GET',
    headers: {
      Authorization: getAuthorizationHeader(user)
    },
    signal
  });

  if (!response.ok) {
    let message = 'Analytics are temporarily unavailable.';
    try {
      const payload = await response.json();
      if (payload?.detail) message = payload.detail;
    } catch (error) {
      // Keep the safe fallback when the server does not return JSON.
    }
    throw new Error(message);
  }

  return response.json();
};
